/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner } from './PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner';
import {
    PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON,
    PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped,
    PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON,
} from './PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner';

/**
 * 
 * @export
 * @interface PostLiffVideoMultiPartUploadSignedurl200Response
 */
export interface PostLiffVideoMultiPartUploadSignedurl200Response {
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoMultiPartUploadSignedurl200Response
     */
    uploadId: string;
    /**
     * 
     * @type {Array<PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner>}
     * @memberof PostLiffVideoMultiPartUploadSignedurl200Response
     */
    parts: Array<PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner>;
}

/**
 * Check if a given object implements the PostLiffVideoMultiPartUploadSignedurl200Response interface.
 */
export function instanceOfPostLiffVideoMultiPartUploadSignedurl200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadId" in value;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponseFromJSON(json: any): PostLiffVideoMultiPartUploadSignedurl200Response {
    return PostLiffVideoMultiPartUploadSignedurl200ResponseFromJSONTyped(json, false);
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffVideoMultiPartUploadSignedurl200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'],
        'parts': ((json['parts'] as Array<any>).map(PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON)),
    };
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponseToJSON(value?: PostLiffVideoMultiPartUploadSignedurl200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadId': value.uploadId,
        'parts': ((value.parts as Array<any>).map(PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON)),
    };
}

